/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pol_OfferedInputs */

const en_pol_offered = /** @type {(inputs: Pol_OfferedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offered by Bystep`)
};

const id_pol_offered = /** @type {(inputs: Pol_OfferedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ditawarkan Bystep`)
};

/**
* | output |
* | --- |
* | "Offered by Bystep" |
*
* @param {Pol_OfferedInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pol_offered = /** @type {((inputs?: Pol_OfferedInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pol_OfferedInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pol_offered(inputs)
	return en_pol_offered(inputs)
});